import { render, staticRenderFns } from "./BusinessPartnerType.vue?vue&type=template&id=4a66f58a&"
import script from "./BusinessPartnerType.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports